import { Box } from '@mui/material'
import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const UIUXDetail = () => {
  return (
    <>

        {/* Career Detail Banner */}
        <section className='about-page'>
            <div className='about-bg'>
                <div className='c-detail-shap-1 con-shap-c'>
                    <img src="../assets/images/whi-5.svg" alt="" />
                </div>
                <div className='about-shap-3'>
                    <img src="../assets/images/about-shap-1.png" alt="" />
                </div>
                <div className='about-shap-4'>
                    <img src="../assets/images/about-shap-2.png" alt="" />
                </div>
                <div className='about-shap-5 con-shap-c'>
                    <img src="../assets/images/about-shap-3.svg" alt="" />
                </div>
                <div className='career-shap-22'>
                    <img src="../assets/images/whi-3.svg" alt="" />
                </div>
                <Container>
                    <Row className='align-items-center'>
                        <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
                            <div className='career-img text-center'>
                                <img src="../assets/images/career-detail-img.png" alt="" />
                            </div>
                            <div className='career-shap-1'>
                                <img src="../assets/images/white-arr.svg" alt="" />
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                            <div className='tech-content'>
                                <h2>UI / UX Designer</h2>
                                <p>At IMUII, our UI/UX Designers craft digital experiences that are not only beautiful but also user-centric. From intuitive wireframes to engaging user flows, you’ll transform complex ideas into seamless, functional designs. We’re looking for a creative thinker who understands design systems, accessibility, and responsive behaviour.  </p>
                                <div className='interest-btn'>
                                    <Link to='/career-form'>
                                        <button className='job-btn'>I’m Interested</button>
                                    </Link>
                                    <Link to='/career-form'>
                                        <button className='friend-btn'>Refer A Friend</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </section>

        {/* Information Section */}
        <section className='information-section'>
            <Container>
                <Row>
                    <div className="col-md-6 mb-30" data-aos="fade-up-right" data-aos-duration="2000">
                        <div className="information-card">
                            <h3>Job Information</h3>
                            <Row>
                                <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <div className='information-icon'>
                                            <img src="../assets/images/c-detail-1.svg" alt="" />
                                        </div>
                                        <div className='information-text'>
                                            <p>Region</p>
                                            <h5>Tamil Nadu</h5>
                                        </div>
                                    </Box>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <div className='information-icon'>
                                            <img src="../assets/images/c-detail-2.svg" alt="" />
                                        </div>
                                        <div className='information-text'>
                                            <p>Industry</p>
                                            <h5>Technology</h5>
                                        </div>
                                    </Box>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                        <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <div className='information-icon'>
                                            <img src="../assets/images/uiux-career.svg" alt="" />
                                        </div>
                                        <div className='information-text'>
                                            <p>Role</p>
                                            <h5>UI / UX Designer</h5>
                                        </div>
                                    </Box>
                                    
                                </div>
                            </Row>
                        </div>
                    </div>
                    <div className="col-md-6 mb-30" data-aos="fade-up-left" data-aos-duration="2000">
                        <div className="information-card">
                            <h3>Other Information</h3>
                            <Row>
                                <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <div className='information-icon'>
                                            <img src="../assets/images/c-detail-4.svg" alt="" />
                                        </div>
                                        <div className='information-text'>
                                            <p>Education</p>
                                            <h5>UG / PG</h5>
                                        </div>
                                    </Box>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-6 information-margin">
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <div className='information-icon'>
                                            <img src="../assets/images/c-detail-5.svg" alt="" />
                                        </div>
                                        <div className='information-text'>
                                            <p>Passed Out</p>
                                            <h5>2019</h5>
                                        </div>
                                    </Box>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 information-margin">
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '10px'
                                    }}>
                                        <div className='information-icon'>
                                            <img src="../assets/images/c-detail-6.svg" alt="" />
                                        </div>
                                        <div className='information-text'>
                                            <p>Salary Range</p>
                                            <h5>₹ 3 to 7 LPA</h5>
                                        </div>
                                    </Box>
                                </div>
                            </Row>
                        </div>
                    </div>
                </Row>
            </Container>
        </section>

        {/* Job Description Section */}
        <section className='job-description-section'>
            <Container>
                <div className='job-description' data-aos="fade-right" data-aos-duration="2000">
                    <h3>Job Description</h3>
                    <p>At IMUII, we’re looking for a UI/UX Designer who thrives at the intersection of creativity and usability. You will be responsible for transforming user needs and business goals into elegant, functional digital experiences. </p>
                    <p>From user journey mapping and wireframing to high-fidelity prototyping, you will bring intuitive interfaces to life. </p>
                    <p>You'll collaborate with product managers, developers, and stakeholders to align design with project objectives while ensuring consistency and accessibility across platforms. A keen eye for detail, understanding of design systems, and ability to iterate quickly based on feedback will define your success in this role. </p>
                </div>
            </Container>
        </section>

        {/* Key Responsibility Section */}
        <section className='key-responsibility-section'>
            <Container>
                <div className='key-responsibility' data-aos="fade-left" data-aos-duration="2000">
                    <h3>Key Responsibility</h3>
                    <ul>
                        <li>
                            <p>Design intuitive and visually appealing interfaces for web and mobile applications using Figma, Adobe XD, or similar tools. </p>
                        </li>
                        <li>
                            <p>Translate product requirements and user research into wireframes, prototypes, and mock-ups that guide development. </p>
                        </li>
                        <li>
                            <p>Conduct usability testing and iterate on designs based on real user feedback and performance metrics. </p>
                        </li>
                        <li>
                            <p>Work closely with developers to ensure seamless integration of UI elements and consistent user experience. </p>
                        </li>
                        <li>
                            <p>Maintain and evolve our design system, ensuring consistency across all digital touchpoints and products. </p>
                        </li>
                        <li>
                            <p>Stay updated with the latest UI/UX trends, best practices, and emerging technologies to keep IMUII at the cutting edge. </p>
                        </li>
                        <li>
                            <p>Communicate design rationale clearly to stakeholders and team members in both technical and non-technical terms </p>
                        </li>
                    </ul>
                </div>

                <div className='btn-margin' data-aos="zoom-in" data-aos-duration="2000">
                    <Link to='/career-form'>
                        <button className='interested-btn'>I’m Interested</button>
                    </Link>
                </div>
            </Container>
        </section>
    
    </>
  )
}